import type { DeviceModel } from '../../types/deviceModel';
import { portRow, powerPort, simpleLayout } from './layoutHelpers';
import type { MultiFaceLayout } from '../../types';

/** UniFi Switch 8 — copper only, no PoE. */
export const us8Model: DeviceModel = {
  equipmentId: 'ubnt-us-8',
  selfDrawWatts: 12,
  powerInputs: [{ id: 'ac', kind: 'ac', portNumber: 1, face: 'back', maxWatts: 55 }],
  layout: {
    multiFace: {
      defaultFace: 'front',
      faces: {
        front: simpleLayout(
          portRow({
            count: 8,
            startNumber: 1,
            kind: 'rj45',
            speedsMbps: [10, 100, 1000],
            y: 22,
          }),
          240,
          70
        ),
        back: simpleLayout(
          [powerPort({ number: 1, kind: 'ac', label: 'AC in', x: 12, y: 20 })],
          140,
          70
        ),
      },
    } as MultiFaceLayout,
  },
};
